import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {DirtyWildsParsedGameData} from "./DirtyWildsParsedGameData";

/**
 * Created by Jonas Wålekvist on 2018-05-03.
 */

export class DirtyWildsModeData {
    get isRandomFeatureTriggered():boolean {
        return this._isRandomFeatureTriggered;
    }

    get nextMode():string {
        return this._nextMode;
    }

    get mode():string {
        return this._mode;
    }

    public static instance:DirtyWildsModeData = new DirtyWildsModeData();

    private _mode:string;
    private _nextMode:string;
    private _isRandomFeatureTriggered:boolean;

    constructor() {

        this.addEventListeners();
    }

    private addEventListeners() {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeStart());
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onGameDataParsed(data:ParsedServerData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._isRandomFeatureTriggered = (<DirtyWildsParsedGameData>data).isRandomFeatureTriggered;
    }

    private onBeforeStart() {

    }
}